import React, { useEffect, useState } from "react";
import Card from "../../../Components/share/cards/Card";
import MainPagination from "../../share/Pageination/MainPagination";

function TeamTable({ teamsList }) {
    const [teamHeads, setTeamHeads] = useState([]);

    const findHeadUser = () => {
        setTeamHeads(
            teamsList.map((team) => team.users.find((x) => x.id === team.head))
        );
    };

    useEffect(() => {
        findHeadUser();
    }, []);

    return (
        <div className="mx-24">
            <Card className="SupportTicketTable-card SupportTicketTable-header SupportTicketTable-card-Fourcol-end mt-[2rem]">
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]  text-right">
                    نام تیم
                </div>
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] text-right">
                    سرگروه
                </div>
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] text-right">
                    نام ایده
                </div>
                <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem] text-right">
                    نام افراد
                </div>
            </Card>
            {teamsList?.map((team, id) => (
                <Card
                    key={team.id}
                    className="SupportTicketTable-card SupportTicketTable-card-Fourcol-end SupportTicketTable-body  my-4 starttable"
                >
                    <div className=" cursor-pointer text-right flex items-center justify-start starttable">
                        {team?.group_name}
                    </div>
                    <div className=" text-right">{teamHeads[id]?.username}</div>
                    <div className=" text-right">{team?.idea_name}</div>
                    <div
                        className="text-right"
                        style={{
                            display: "flex",
                            gap: "2rem",
                        }}
                    >
                        {team?.users.map((user) => (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                {user.username}
                            </div>
                        ))}
                    </div>
                </Card>
            ))}
        </div>
    );
}

export default TeamTable;
